/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import Spinner from "../components/spinner";

const KeyPerson = ({ handleNext, preId, keyPersonName, setKeyPersonName }) => {
  const location = useLocation();
  const { state } = location;
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false);
  const [inputKeyValue, setInputKeyValue] = useState('');
  const [contact, setContact] = useState(0)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [validInputKey, setValidInputKey] = useState("key");
  const [validContact, setValidContact] = useState("contact");
  const [validSelect, setValidSelect] = useState('select');

  const validateForm = () => {
    let valid = false;
    if (inputKeyValue === "") {
      setValidInputKey(inputKeyValue);
      valid = true;
    }
    let regex = new RegExp(/^[0-9]{10}$/);
    const validRegexCon = regex.test(contact);

    if (contact === "") {
      setValidContact(contact);
      valid = true;
    }
    else if (validRegexCon === false) {
      setValidContact(validRegexCon);
      valid = true;
    }
    return valid;
  };
  const validateSelect = (name, value) => {
    let valid = false;

    if (!keyPersonName) {
      setValidSelect(keyPersonName);
      valid = true;
    }
    return valid;
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setValidInputKey('key')
    setValidContact('contact')
    setInputKeyValue('')
    setContact('')
  };

  const handleSave = async () => {
    if (!validateForm()) {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/create-key-person`,
          {
            nameOfKey: inputKeyValue,
            contact: contact,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('signIn')}`,
            },
          }
        );

        if (response.status === 201) {
          setIsModalOpen(false);
          setInputKeyValue('')
          setContact('')
          handleData();
          setKeyPersonName({
            value: response.data.result.id,
            label: `${response.data.result.nameOfKey} - ${response.data.result.contact}`,
          });
          setValidSelect({
            value: response.data.result?.id,
            label: `${response.data.result.nameOfKey} - ${response.data.result.contact}`
          })
        }

      } catch (error) {
        console.error('Error submitting KeyPerson data:', error);
      }
    }
  };

  const handleKeyDetails = async (e) => {
    e.preventDefault();
    if (preId === '' && state === null) {
      try {
        setIsLoading(true);
        if (!validateSelect()) {
          const response = await axios.post(`${process.env.REACT_APP_API_URL}/create-project`,
            {
              key_Id: keyPersonName.value
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('signIn')}`
              }
            }
          );
          if (response.status === 201) {
            localStorage.setItem('projectId', response.data.result.id)
            handleNext()
          }
        }
      } catch (error) {
        console.error('Error submitting KeyPerson data:', error);
      } finally {
        setIsLoading(false);
      }

    } else {
      try {
        setIsLoading(true);
        if (!validateSelect()) {
          const response = await axios.put(`${process.env.REACT_APP_API_URL}/update-project/${preId || state.projectId}`,
            {
              key_Id: keyPersonName.value
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('signIn')}`
              }
            }
          );
          if (response.status === 200) {
            localStorage.setItem('projectId', response.data.result.id)
            handleNext()
          }
        }
      } catch (error) {
        console.error('Error submitting KeyPerson data:', error);
      } finally {
        setIsLoading(false);
      }

    }
  };

  const handleData = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/get-person-detials`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('signIn')}`
        }
      }
    );
    const options = response.data?.result.map((value) => ({
      value: value.id,
      label: `${value.nameOfKey} - ${value.contact}`,
    }));
    setData(options);
  };

  const handleEditData = async () => {
    if (preId !== '' || (state && state.editMode === true)) {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/projects/${preId || state.projectId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('signIn')}`
          }
        }
      );
      setKeyPersonName({
        value: response.data.result?.key_Id,
        label: `${response.data.result.nameOfKey} - ${response.data.result.contact}`
      })

    }
  }

  useEffect(() => {
    handleData();
    handleEditData()
  }, [state]);

  return (
    <div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="container card card-body">
          <div className="row justify-content-center">
            <form className="form-horizontal">
              <div className='form-group row align-items-center'>
                <label className='col-sm-4 col-form-label text-center'>
                  Name of Key
                </label>
                <div className='col-sm-4'>
                  <Select
                    className={`${validSelect === null && 'is-invalid'}`}
                    options={data}
                    value={keyPersonName}
                    onChange={(selectedOption) => {
                      setKeyPersonName(selectedOption);
                      setValidSelect(selectedOption)
                    }}
                    placeholder="Select"
                  />
                  {validSelect === null && (
                    <p className="invalid-feedback">Please select key</p>
                  )}
                </div>
                <div className='col-sm-4'>
                  <button
                    type="button"
                    style={{ border: '1px solid gray' }}
                    className='btn btn-outline-secondary col-xs-offset-1'
                    onClick={() => { handleOpenModal(); }}
                  ><i className="bi bi-plus-lg"></i></button>
                </div>
                <Modal show={isModalOpen} onHide={handleCloseModal}>
                  <Modal.Header closeButton>
                    <Modal.Title>Key Person</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form>
                      <Form.Group className="mb-3">
                        <Form.Label>Name of Key</Form.Label>
                        <Form.Control
                          className={`form-control ${validInputKey === '' && 'is-invalid'}`}
                          type="text"
                          name="nameOfKey"
                          onChange={(e) => {
                            setInputKeyValue(e.target.value);
                            setValidInputKey(e.target.value);
                          }}
                        />
                        {validInputKey === '' && (
                          <p className="invalid-feedback">Name of Key is required</p>
                        )}
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Contact Number</Form.Label>
                        <Form.Control
                          className={`form-control ${(validContact === '' || validContact === false) && 'is-invalid'}`}
                          type="number"
                          name="contact"
                          value={contact}
                          onChange={(e) => {
                            setContact(e.target.value);
                            setValidContact(e.target.value);
                          }}
                        />
                        {validContact === '' ? (
                          <div className="invalid-feedback">Contact Number is required</div>
                        ) : <div className="invalid-feedback">Contact Number must be exactly 10 digits</div>}
                      </Form.Group>
                    </Form>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                      Close
                    </Button>
                    <Button variant="primary" onClick={handleSave}>
                      Save
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>

              <div className='d-grid gap-2 d-md-flex justify-content-md-end'>
                <div className='form-group text-center'>
                  <button
                    type="button"
                    style={{ border: '1px solid gray' }}
                    className="btn btn-default col-xs-offset-1"
                    onClick={handleKeyDetails}
                  >
                    Next
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default KeyPerson;
